import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setPlaybookType } from './store/playbook_type/actions';

import { Nav } from 'react-bootstrap-5';

export function PlaybookDealTypes({ playbookType, playbookTypeOptions, setPlaybookType }) {
  return (
    <Nav
      activeKey={playbookType}
      variant="pills"
      onSelect={setPlaybookType}
    >
      {playbookTypeOptions.map(option => (
        <Nav.Item key={option.value}>
          <Nav.Link eventKey={option.value}>{option.label}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}


PlaybookDealTypes.propTypes = {
  playbookType: PropTypes.string.isRequired,
  playbookTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setPlaybookType: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  playbookType: state.playbookType,
  playbookTypeOptions: state.playbookTypeOptions,
});

const mapDispatchToProps = {
  setPlaybookType,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaybookDealTypes);
